import { ChevronArrowRightIcon, CopyIcon } from 'assets/icons';
import { useAppDispatch } from 'hooks';
import { FC } from 'react';
import { VoidFn } from 'types/baseTypes';
import { NotifierTypes } from 'constants/notifierConstants';
import { copyToClipBoard } from 'utils/commonUtils';
import { showNotification } from 'utils/Notifier';
import { If } from 'components';

const COPIED_MESSAGE = 'Copied to clipboard.';

export interface HelpSupportRowProps {
  icon: React.ReactNode;
  title: string;
  subtitle: string;
  description?: string;
  onClick: VoidFn;
  ariaLabel: string;
  showCopyIcon?: boolean;
  copyMessage?: string;
}

const HelpSupportRow: FC<HelpSupportRowProps> = ({
  icon,
  title,
  subtitle,
  description,
  onClick,
  ariaLabel,
  showCopyIcon = false,
  copyMessage = ''
}) => {
  const dispatch = useAppDispatch();

  const handleCopyClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!subtitle.trim()) return;
    copyToClipBoard(subtitle.replace(/\s/g, '').trim());
    showNotification(dispatch, NotifierTypes.SUCCESS, copyMessage, 4000, copyMessage);
  };

  return (
    <div
      role="button"
      tabIndex={0}
      aria-label={ariaLabel}
      onClick={onClick}
      className="flex cursor-pointer flex-row items-center justify-between gap-4 rounded-lg border
        border-borderGray bg-primary p-4 hover:bg-secondaryBtn">
      <div className="flex flex-row items-center gap-4">
        <div className="shrink-0 text-accentText">{icon}</div>
        <div className="flex flex-col gap-0.5">
          <span className="text-sbase font-normal text-primaryText">{title}</span>
          <div className="flex flex-row items-center gap-1">
            <span className="text-sbase text-accentText">{subtitle}</span>
            <If condition={showCopyIcon}>
              <button
                type="button"
                onClick={handleCopyClick}
                className="shrink-0 cursor-pointer rounded p-0.5 hover:bg-borderGray"
                aria-label="Copy">
                <CopyIcon className="path-fill-current h-4 w-4 text-accentText" />
              </button>
            </If>
          </div>
          {description && <span className="text-px13 text-accentText">{description}</span>}
        </div>
      </div>
      <ChevronArrowRightIcon className="path-fill-current h-4 w-4 shrink-0 text-accentText" />
    </div>
  );
};

export default HelpSupportRow;
